module.exports = __webpack_public_path__ + "static/media/logo.95609d0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/logo.svg
// module id = 349
// module chunks = 0